var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23L22.785 18.5L15 14V23ZM32.34 11.255C32.535 11.96 32.67 12.905 32.76 14.105C32.865 15.305 32.91 16.34 32.91 17.24L33 18.5C33 21.785 32.76 24.2 32.34 25.745C31.965 27.095 31.095 27.965 29.745 28.34C29.04 28.535 27.75 28.67 25.77 28.76C23.82 28.865 22.035 28.91 20.385 28.91L18 29C11.715 29 7.8 28.76 6.255 28.34C4.905 27.965 4.035 27.095 3.66 25.745C3.465 25.04 3.33 24.095 3.24 22.895C3.135 21.695 3.09 20.66 3.09 19.76L3 18.5C3 15.215 3.24 12.8 3.66 11.255C4.035 9.905 4.905 9.035 6.255 8.66C6.96 8.465 8.25 8.33 10.23 8.24C12.18 8.135 13.965 8.09 15.615 8.09L18 8C24.285 8 28.2 8.24 29.745 8.66C31.095 9.035 31.965 9.905 32.34 11.255Z",
    fill: "#EB2121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube_logo.09a9ebfeb224b130a7912e5927bc920c.svg";
export { ForwardRef as ReactComponent };